import * as React from "react";
import { Newsletter as Newsletter$1 } from "@grandvisionhq/content";
import { compose } from "@grandvisionhq/utils";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { useBloomreachNewsletterData } from "../../../../hooks/hooks/use-bloomreach-newsletter-data.js";
import { parseBloomreachImage } from "../../../../utils/utils/parse-bloomreach-image.js";
const CmsNewsletter = ({ component, meta }) => {
  const newsletterData = useBloomreachNewsletterData();
  const { newsletterImage } = component.getModels();
  const image = parseBloomreachImage(newsletterImage);
  const alignment = meta.template.includes("right") ? "right" : "left";
  return /* @__PURE__ */ React.createElement(
    Newsletter$1,
    {
      ...newsletterData,
      alignment,
      image: image?.original,
      mobileImage: image?.mobile,
      variant: "bloomreach-component"
    }
  );
};
const Newsletter = compose(
  withHidableContent,
  withBloomreachData,
  withEditableContent
)(CmsNewsletter);
export {
  CmsNewsletter,
  Newsletter as default
};
//# sourceMappingURL=Newsletter.js.map
